<p-fileUpload
    #fileUpload
    name="media[]"
    [customUpload]="true"
    [multiple]="true"
    accept=".jpg,.jpeg,.png,.mp4,.mov"
    [maxFileSize]="1000000000"
    [showUploadButton]="false"
    [showCancelButton]="false"
    styleClass="hidden"
    (onSelect)="onFileSelect(); openDialog()"
    (clear)="onClearSelection()"
    (uploadHandler)="onUploadHandler($event)"
/>

<p-button
  icon="pi pi-upload"
  label="Hochladen"
  (click)="fileUpload.choose()"
/>

<p-dialog
  header="Auswahl prüfen & hochladen"
  [(visible)]="dialogVisible"
  [modal]="true"
  [style]="{ width: '80vw' }"
  [closable]="true"
  [dismissableMask]="true"
  appendTo="body"
  (onHide)="onDialogHide()"
>
  <div *ngFor="let file of selectedFiles; let i = index" class="p-4">
    <div class="grid grid-cols-[180px_1fr_1fr_180px_30px] gap-4 items-center">
      <div class="flex flex-row gap-2 w-[140px] shrink-0">
        {{ file.type }}
        <ng-container *ngIf="isImage(file); else videoPreview">
          <img [src]="file.objectURL" class="w-[150px] h-[150px] min-w-full object-contain rounded border border-gray-300" alt="preview"/>
        </ng-container>
        <ng-template #videoPreview>
          <video [src]="file.objectURL" class="w-[150px] h-[150px] min-w-full object-contain rounded border border-gray-300" controls></video>
        </ng-template>

        <div class="flex flex-col gap-2 justify-center">
          <span
            class="flex items-center justify-center w-8 h-8 rounded-full text-white cursor-pointer"
            [ngClass]="file.syncWithWebsite ? 'bg-[#8db43f]' : 'bg-gray-400'"
            title="Website"
            (click)="file.syncWithWebsite = !file.syncWithWebsite"
          >
            <i class="pi pi-globe"></i>
          </span>
          <span
            class="flex items-center justify-center w-8 h-8 rounded-full text-white cursor-pointer"
            [ngClass]="file.syncWithSharedFolder ? 'bg-[#8db43f]' : 'bg-gray-400'"
            title="Speichern"
            (click)="file.syncWithSharedFolder = !file.syncWithSharedFolder"
          >
            <i class="pi pi-file-export"></i>
          </span>
        </div>
      </div>

      <div class="flex flex-col">
        <label class="text-sm font-semibold text-gray-600 mb-1">
          <i class="pi pi-comment mr-2"></i> Beschreibung:
        </label>
        <textarea [(ngModel)]="file.description"
                  class="border border-[#8db43f] rounded p-2 w-full min-h-[6rem]"></textarea>
      </div>

      <div class="flex flex-col">
        <label class="text-sm font-semibold text-gray-600 mb-1">
          <i class="pi pi-globe mr-2"></i> Website-Beschreibung
        </label>
        <textarea [(ngModel)]="file.externalDescription"
                  class="border border-[#8db43f] rounded p-2 w-full min-h-[6rem]"></textarea>
      </div>

      <div class="flex flex-col items-start">
        <label class="text-sm font-semibold text-gray-600 text-center block mb-2">KATEGORIE</label>
        <div class="flex flex-col gap-2">
          <div *ngFor="let cat of mediaCategoryOptions">
            <div class="flex items-center gap-2">
              <p-checkbox
                [attr.inputId]="'cat_' + cat.value + '_' + i"
                name="category"
                [value]="cat.value"
                [(ngModel)]="file.category"
                [binary]="false"
              ></p-checkbox>
              <label [for]="'cat_' + cat.value + '_' + i" class="text-sm">{{ cat.name }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col">
        <p-button
          (click)="removeFile(i)"
          icon="pi pi-trash"
          [rounded]="true"
          severity="danger"
        />
      </div>
    </div>

    @if (selectedFiles.length > 1 && i < selectedFiles.length - 1) {
      <p-divider></p-divider>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-upload"
      label="Auswahl hochladen"s
      (click)="uploadFiles()"
      [disabled]="!selectedFiles.length"
    />
  </ng-template>
</p-dialog>
